// 9fbef606107a605d69c0edbcd8029e5d
import { PRODUCT_PICKUP_ACTION_PATTERN } from '../../../../constants/reducer.constants';

const PRODUCT_PICKUP_ACTIONS_CONSTANTS = {
  SET_BOPIS_INVENTORY: `${PRODUCT_PICKUP_ACTION_PATTERN}SET_BOPIS_INVENTORY`,
  GET_BOPIS_INVENTORY: `${PRODUCT_PICKUP_ACTION_PATTERN}GET_BOPIS_INVENTORY`,
  SET_CHANGED_SELECTED_STORE: `${PRODUCT_PICKUP_ACTION_PATTERN}SET_CHANGED_SELECTED_STORE`,
  RESET_CHANGED_SELECTED_STORE: `${PRODUCT_PICKUP_ACTION_PATTERN}RESET_CHANGED_SELECTED_STORE`,
  FROM_AVAILABLE_STORES_CLICK: `${PRODUCT_PICKUP_ACTION_PATTERN}FROM_AVAILABLE_STORES_CLICK`,
  FROM_AVAILABLE_STORES_CLICK_RESET: `${PRODUCT_PICKUP_ACTION_PATTERN}FROM_AVAILABLE_STORES_CLICK_RESET`,
  SET_FROM_RECOMMENDATIONS_QV: `${PRODUCT_PICKUP_ACTION_PATTERN}SET_FROM_RECOMMENDATIONS_QV`,
  SET_RECOMM_BOPIS_INVENTORY: `${PRODUCT_PICKUP_ACTION_PATTERN}SET_RECOMM_BOPIS_INVENTORY`,
  GET_STORE_SPECIFIC_INVENTORY: `${PRODUCT_PICKUP_ACTION_PATTERN}.GET_STORE_SPECIFIC_INVENTORY`,
  GET_STORE_SPECIFIC_INVENTORY_SUCCESS: `${PRODUCT_PICKUP_ACTION_PATTERN}.GET_STORE_SPECIFIC_INVENTORY_SUCCESS`,
};

export default PRODUCT_PICKUP_ACTIONS_CONSTANTS;
